import {React} from "react";
import   "./styles.css";

import TextImage from "../Common/TextImage";
import ImageText from "../Common/ImageText"
import  Neighbors from "../images/carris.png"
import bao_bah from "../images/blackandorange_bettyandharry.jpg"



const Home = () => {

     return (
<div style={{background:'#eceff3f6'}}>
      <div  >
          <h1 className={'boldFancyHeadFontCenter'}>Membership Process/Costs and Fees</h1>
          <h3 className='boldFancyHeadFontCenter3'>The How-To and How-Much of the Kermis Dance Club</h3>
        <div/>  
      </div>
      <div>
     
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={Neighbors}
          myText="We would love for you to become a member of Kermis but we do have a couple of rules.||
                All members are couples.  We don't allow individuals in the club without a partner.  You don't have to be married or dating, but you do have to be two.||
                Our events are formal.  This means tuxedos for men and evening wear for women.   It may seem a little old-fashioned but it does add to the shine of our events.||
                ||Now, what must be done to become a member couple? |While the process may seem daunting, it is an extreme rarity for it not result in approval.|
                So, lace your shoes and twirl your skirts, here is the process.||First, you will need a sponsor to attend an event as a guest couple.  |
                You don't know any current members of Kermis?|No problem, just head over to our contact page and request to be a guest. |We will match you to a sponsor.||
                Once you have attended an event and are interested, your sponsor can then apply on your behalf to become a member couple.  || 
                After the application is received, two other members will endorse the application and it shall be presented to the President.||
                The President will then direct the application to the Membership Committee for investigation and recommendation.||
                You will be notified as soon as the process is complete."
            />
      </div>

      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <TextImage 
          selImage={bao_bah}
          myText="What happens after you become a member couple?||
                There is a fee to be a member of $150 per couple per year and each event has a cost of $225 per couple per event.||
                If you are attending as a guest, then the event cost is $250 per couple.||
                As we are a non-profit club, this covers our basic expenses for facility rental and catering. (All of the board members are unpaid volunteers.)|
                Each event does have a cash bar for wine, beer and cocktails.||
                No one is required to attend any event."
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage=''
          myText="Now that you know the ins and outs of our membership process and fees, what's keeping you from joining the fun?"
            />
            </div>
      
          
        </div>
        </div>
     )
   };
   
   export default Home;